<script setup lang="ts">
import { Icon } from "@iconify/vue";

export type BaseIconProps = {
  name: `heroicons:${string}`;
  size?: number;
  color?: string;
};

defineProps<BaseIconProps>();
</script>

<template>
  <Icon
    :width="size ?? 24"
    :height="size ?? 24"
    class="inline-block"
    :class="color ? `text-${color}` : ''"
    :icon="name"
  />
</template>
